import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { RentReportingData } from "views/rent-reporting-id/types";

export const useRentalVerifications = (rvId: string) => {
  return useQuery({
    queryKey: ["RENTAL_VERIFICATIONS", rvId],
    queryFn: () =>
      instance
        .get(`/portal/v1/enrollments/${rvId}/rental_verifications`)
        .then(
          ({
            data
          }: {
            data: RentReportingData[] | { items?: RentReportingData[] };
          }) => {
            return Array.isArray(data) ? data : data.items || [];
          }
        ),
    enabled: Boolean(rvId)
  });
};
